import React from "react";
import styles from "./CSS/SocialHome.module.css";
import PostBox from "./Comps/PostBox";
import SocialHead from "./Comps/SocialHead";
import PostCard from "./Comps/PostCard";

const SocialHome = () => {
  const dummyPosts = [
    {
      phoneNumber: "03001234567",
      postText: "Enjoying a day at the beach!",
      image: "https://via.placeholder.com/400x250.png?text=Beach+Day",
    },
    {
      phoneNumber: "03001234567",
      postText: "Enjoying a day at the beach!",
      image: "https://via.placeholder.com/400x250.png?text=Beach+Day",
    },
    {
      phoneNumber: "03001234567",
      postText: "Enjoying a day at the beach!",
      image: "https://via.placeholder.com/400x250.png?text=Beach+Day",
    },
    {
      phoneNumber: "03001234567",
      postText: "Enjoying a day at the beach!",
      image: "https://via.placeholder.com/400x250.png?text=Beach+Day",
    },

    {
      phoneNumber: "03001234567",
      postText: "Enjoying a day at the beach!",
      image: "https://via.placeholder.com/400x250.png?text=Beach+Day",
    },
    {
      phoneNumber: "03119876543",
      postText: "Checkout this cool design I made.",
      image: "https://via.placeholder.com/400x250.png?text=Cool+Design",
    },
    {
      phoneNumber: "03208648637",
      postText: "Jazz Day celebrations are awesome!",
      image:
        "https://img.freepik.com/premium-psd/international-jazz-day-social-post-background_1028932-1623.jpg",
    },
  ];
  return (
    <>
      <div className={styles.MainConatiner}>
        <SocialHead />
        <PostBox />
        {dummyPosts.map((post, index) => (
          <PostCard
            key={index}
            phoneNumber={post.phoneNumber}
            postText={post.postText}
            image={post.image}
          />
        ))}
      </div>
    </>
  );
};

export default SocialHome;
